import { z } from 'zod'
import { ApiLocale } from '@library/enums'
import { areaSchema } from './area'
import { countrySchema } from './country'
import { stationSchema } from './station'

/** 區域、國家與場站 對應資料 Schema */
export const areaCountryStationSchema = z.object({
  lang: z.enum(ApiLocale),
  area: z.array(areaSchema),
  country: z.array(countrySchema),
  station: z.array(stationSchema)
})

/** 區域、國家與場站 對應資料 */
export interface AreaCountryStation
  extends z.infer<typeof areaCountryStationSchema> {}
